import React, { FC } from 'react'

import { WithDataName } from 'common/types'
import { VerifiedIconParams } from 'components/presentational/title/common.types'
import { VerifiedIcon } from 'components/presentational/title/VerifiedIcon'
import { VerifiedIconWithTooltip } from 'components/presentational/title/VerifiedIconWithTooltip'

export const VerifiedIconWrapper: FC<VerifiedIconParams & WithDataName> = ({
  name,
  gender,
  iconUid,
  ...rest
}) => {
  if (!gender) {
    return <VerifiedIcon data-name={rest['data-name']} iconUid={iconUid} />
  }

  return (
    <VerifiedIconWithTooltip name={name} gender={gender} iconUid={iconUid} />
  )
}
